var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 5.83329C1.66663 5.39127 1.84222 4.96734 2.15478 4.65478C2.46734 4.34222 2.89127 4.16663 3.33329 4.16663H16.6666C17.1087 4.16663 17.5326 4.34222 17.8451 4.65478C18.1577 4.96734 18.3333 5.39127 18.3333 5.83329V14.1666C18.3333 14.6087 18.1577 15.0326 17.8451 15.3451C17.5326 15.6577 17.1087 15.8333 16.6666 15.8333H3.33329C2.89127 15.8333 2.46734 15.6577 2.15478 15.3451C1.84222 15.0326 1.66663 14.6087 1.66663 14.1666V5.83329Z",
    stroke: "#374151",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#374151",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.49996C2.55068 7.49996 3.39853 7.14877 4.02365 6.52365C4.64877 5.89853 4.99996 5.05068 4.99996 4.16663",
    stroke: "#374151",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.8333C15 14.9493 15.3512 14.1014 15.9763 13.4763C16.6014 12.8512 17.4493 12.5 18.3333 12.5",
    stroke: "#374151",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMoney;